import { render, staticRenderFns } from "./BottomOptionList.vue?vue&type=template&id=8dc09b08&scoped=true&"
import script from "./BottomOptionList.vue?vue&type=script&lang=js&"
export * from "./BottomOptionList.vue?vue&type=script&lang=js&"
import style0 from "./BottomOptionList.vue?vue&type=style&index=0&id=8dc09b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc09b08",
  null
  
)

export default component.exports